import { c as _c } from "react/compiler-runtime";
import clsx from 'clsx';
import { createElement, FC, ReactNode, Ref } from 'react';
import { Button } from './Button';
import './notification.scss';
type NotificationVariant = 'neutral' | 'success' | 'danger';
export interface NotificationProps {
  variant?: NotificationVariant;
  title: ReactNode;
  actions?: ReactNode[];
  isDismissible?: boolean;
  onDismiss?: () => void;
  className?: string;
  ref?: Ref<HTMLDivElement>;
}
export const Notification: FC<NotificationProps> = t0 => {
  const $ = _c(28);
  const {
    ref,
    variant: t1,
    title,
    actions,
    isDismissible,
    onDismiss,
    className
  } = t0;
  const variant = t1 === undefined ? "neutral" : t1;
  const t2 = `tds-notification--${variant}`;
  const t3 = actions && actions.length > 0;
  let t4;
  if ($[0] !== className || $[1] !== isDismissible || $[2] !== t2 || $[3] !== t3) {
    t4 = clsx("tds-notification", t2, {
      "tds-notification--with-buttons": t3,
      "tds-notification-dismissible": isDismissible
    }, className);
    $[0] = className;
    $[1] = isDismissible;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const notificationClasses = t4;
  let t5;
  if ($[5] !== variant) {
    t5 = () => {
      switch (variant) {
        case "success":
          {
            return <SuccessIcon />;
          }
        case "danger":
          {
            return <DangerIcon />;
          }
        default:
          {
            return <InfoIcon />;
          }
      }
    };
    $[5] = variant;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const getIcon = t5;
  const t6 = variant === "danger" ? "alert" : "status";
  const t7 = variant === "danger" ? "assertive" : "polite";
  const t8 = `${variant === "danger" ? "Kriitiline hoiatus" : "Informatsioon"}: ${title}`;
  let t9;
  if ($[7] !== getIcon) {
    t9 = <div className="tds-notification-icon">{getIcon()}</div>;
    $[7] = getIcon;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  const t10 = typeof title === "string" ? "p" : "div";
  let t11;
  if ($[9] !== t10 || $[10] !== title) {
    t11 = createElement(t10, {
      className: "tds-notification-title",
      id: "notification-title"
    }, title);
    $[9] = t10;
    $[10] = title;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] !== actions) {
    t12 = actions && actions.length > 0 && <div className="tds-notification-buttons">{actions.map(_temp)}</div>;
    $[12] = actions;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  let t13;
  if ($[14] !== t11 || $[15] !== t12) {
    t13 = <div className="tds-notification-content">{t11}{t12}</div>;
    $[14] = t11;
    $[15] = t12;
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  let t14;
  if ($[17] !== isDismissible || $[18] !== onDismiss) {
    t14 = isDismissible && <Button type="button" variant="icon-neutral" compact={true} className="tds-notification-close shrink-0" aria-label="Sulge" onClick={onDismiss}><CloseIcon /></Button>;
    $[17] = isDismissible;
    $[18] = onDismiss;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  if ($[20] !== notificationClasses || $[21] !== t13 || $[22] !== t14 || $[23] !== t6 || $[24] !== t7 || $[25] !== t8 || $[26] !== t9) {
    t15 = <div ref={ref} className={notificationClasses} role={t6} aria-live={t7} aria-label={t8}>{t9}{t13}{t14}</div>;
    $[20] = notificationClasses;
    $[21] = t13;
    $[22] = t14;
    $[23] = t6;
    $[24] = t7;
    $[25] = t8;
    $[26] = t9;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  return t15;
};
export const InfoIcon: FC = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none"><circle cx="16" cy="16" r="16" fill="#0072CE" /><path d="M15.75 11C16.7165 11 17.5 10.2165 17.5 9.25C17.5 8.2835 16.7165 7.5 15.75 7.5C14.7835 7.5 14 8.2835 14 9.25C14 10.2165 14.7835 11 15.75 11Z" fill="white" /><path d="M13.5 13H17.5V21H18.5V23H13.5V21H14.5V15H13.5V13Z" fill="white" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export const SuccessIcon: FC = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none"><circle cx="16" cy="16" r="16" fill="#017E31" /><path fillRule="evenodd" clipRule="evenodd" d="M24.224 9.86711L14.7406 23.2555L7.48642 16.6058L9.51359 14.3944L14.2594 18.7447L21.776 8.13306L24.224 9.86711Z" fill="white" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export const DangerIcon: FC = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg xmlns="http://www.w3.org/2000/svg" width="32" height="30" viewBox="0 0 32 30" fill="none"><path d="M14.2526 1.07143C15.0292 -0.357142 16.9708 -0.357143 17.7474 1.07143L31.7267 26.7857C32.5033 28.2143 31.5325 30 29.9793 30H2.02074C0.467492 30 -0.50329 28.2143 0.273335 26.7857L14.2526 1.07143Z" fill="#D51A27" /><path d="M14.25 10H17.75L17.25 20H14.75L14.25 10Z" fill="white" /><path d="M16 25C16.9665 25 17.75 24.2165 17.75 23.25C17.75 22.2835 16.9665 21.5 16 21.5C15.0335 21.5 14.25 22.2835 14.25 23.25C14.25 24.2165 15.0335 25 16 25Z" fill="white" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export const CloseIcon: FC = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path fillRule="evenodd" clipRule="evenodd" d="M9.99974 11.1785L4.75566 16.4226L3.57715 15.2441L8.82123 9.99998L3.57715 4.7559L4.75566 3.57739L9.99974 8.82147L15.2438 3.57739L16.4223 4.7559L11.1782 9.99998L16.4223 15.2441L15.2438 16.4226L9.99974 11.1785Z" fill="#131416" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
function _temp(action, index) {
  return <span key={index}>{action}</span>;
}